import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

import * as Sentry from '@sentry/angular-ivy';

import {MoConsole} from '@customcoding/shared';


(globalThis as any).MoConsole = MoConsole;

MoConsole.loggingLevel.set(environment.loggingLevel ?? 0);

if (environment.production) {
	enableProdMode();
	Sentry.init({
		dsn: environment.sentryDSN,
		integrations: [
			Sentry.browserTracingIntegration(),
		],
		autoSessionTracking: false,
		tracePropagationTargets: [],
		tracesSampleRate: .2,
		maxBreadcrumbs: 20,
		attachStacktrace: false,
	});
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => MoConsole.error(err));
